import { notification } from 'antd';
import { ArgsProps } from 'antd/lib/notification';
import { AxiosError } from 'axios';

type NotificationConfig = Omit<ArgsProps, 'description' | 'message'> & {
  translate?: (errors: string[]) => string[];
  description?: string;
  message?: React.ReactNode;
};

type DataError = {
  message?: string;
};

const statusError = [400, 404];

export default function notificationError(
  error: unknown,
  config?: NotificationConfig,
) {
  const err = error as AxiosError;
  let data: DataError | DataError[] | undefined;

  if (err?.isAxiosError) {
    if (err?.response?.status === 403) {
      return null;
    }
    data = err?.response?.data;
  } else {
    data = { ...data, message: err?.message };
  }

  const handleDescription = (text?: string) =>
    text || 'Não foi possível finalizar a requisição, tente novamente.';

  const description = Array.isArray(data) ? (
    <>
      {config?.translate
        ? config
            .translate(data.map((item) => item.message || ''))
            .map((message, i) => (
              <div key={i}>
                {handleDescription(message || config?.description)}
              </div>
            ))
        : data.map(({ message }, i) => (
            <div key={i}>
              {handleDescription(message || config?.description)}
            </div>
          ))}
    </>
  ) : config?.translate ? (
    config.translate([data?.message || ''])[0]
  ) : err?.response?.status && statusError.includes(err?.response?.status) ? (
    config?.description || data?.message || 'Não foram encontradas informações.'
  ) : (
    handleDescription(data?.message || config?.description)
  );

  notification[config?.type || 'error']({
    ...config,
    message: config?.message ?? 'Impossibilidade de envio',
    description,
  });
}
